import React, { useEffect, useRef } from "react";
import { ChatMessageBubble } from "./ChatMessageBubble";
import { useChatStore } from "./chatStore";

interface ChatMessageListProps {
  onConfirm?: () => void;
  onReject?: () => void;
}

export const ChatMessageList: React.FC<ChatMessageListProps> = ({ onConfirm, onReject }) => {
  const messages = useChatStore((s) => s.messages);
  const toolCalls = useChatStore((s) => s.toolCalls);
  const toolResults = useChatStore((s) => s.toolResults);
  const confirmationRequest = useChatStore((s) => s.confirmationRequest);
  const bottomRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, toolCalls, toolResults, confirmationRequest]);

  // Find the index of the last assistant message
  let lastAssistantIdx = -1;
  for (let i = messages.length - 1; i >= 0; i--) {
    if (messages[i].role === "assistant") {
      lastAssistantIdx = i;
      break;
    }
  }

  return (
    <div className="chat-messages">
      {messages.map((msg, i) => (
        <ChatMessageBubble
          key={msg.localId}
          message={msg}
          isLastAssistant={i === lastAssistantIdx}
          toolCalls={i === lastAssistantIdx ? toolCalls : undefined}
          toolResults={i === lastAssistantIdx ? toolResults : undefined}
          confirmation={i === lastAssistantIdx ? confirmationRequest : undefined}
          onConfirm={i === lastAssistantIdx ? onConfirm : undefined}
          onReject={i === lastAssistantIdx ? onReject : undefined}
        />
      ))}
      <div ref={bottomRef} />
    </div>
  );
};
